// Permissões dos usuários
(function () {
  'use strict';

  // Variáveis
  const $selectAll = $('.select-all-permissoes');
  const $permissoes = $('.permissao');
  const totalPermissoes = $permissoes.length;

  $selectAll.on('change', function () {
    if ($(this).is(':checked')) {
      selectAll();
    } else {
      disableAll();
    }
  });

  $permissoes.on('change', function () {
    updateSelectAll();
  });

  // Seleciona todas as permissões
  function selectAll() {
    $permissoes.prop('checked', true);
  }

  // Desmarca todas as permissões
  function disableAll() {
    $permissoes.prop('checked', false);
  }

  // Atualiza o campo de selecionar todas
  function updateSelectAll() {
    if (getTotalChecked() === totalPermissoes) {
      $selectAll.prop('checked', true);
    } else {
      $selectAll.prop('checked', false);
    }
  }

  // Retorna a quantidade permissões selecionadas
  function getTotalChecked() {
    return $('.permissao:checked').length;
  }
})();
